export class Deferred<T> implements Promise<T> {
	private _resolveSelf
	private _rejectSelf

	private _isPending = true

	public promise: Promise<T>

	constructor() {
		this.promise = new Promise<T>((resolve, reject) => {
			this._resolveSelf = resolve
			this._rejectSelf = reject
		})
	}

	// biome-ignore lint/suspicious/noThenProperty: <explanation>
	public then<TResult1 = T, TResult2 = never>(
		onfulfilled?:
			| ((value: T) => TResult1 | PromiseLike<TResult1>)
			| undefined
			| null,
		onrejected?:
			| ((reason: any) => TResult2 | PromiseLike<TResult2>)
			| undefined
			| null,
	): Promise<TResult1 | TResult2> {
		return this.promise.then(onfulfilled, onrejected)
	}

	public catch<TResult = never>(
		onrejected?:
			| ((reason: any) => TResult | PromiseLike<TResult>)
			| undefined
			| null,
	): Promise<T | TResult> {
		return this.promise.then(onrejected)
	}

	finally(onfinally?: () => void): Promise<T> {
		return this.promise.finally(onfinally)
	}

	public resolve(val: T) {
		if (!this._isPending) {
			return
		}

		this._resolveSelf(val)

		this._isPending = false
	}
	public reject(reason: any) {
		if (!this._isPending) {
			return
		}

		this._rejectSelf(reason)

		this._isPending = false
	}

	[Symbol.toStringTag]: 'Promise'
}
